module.exports = __webpack_public_path__ + "img/Wolt3.c8ede9ef.png";